var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { computed } from 'vue';
import { ActionEnum } from '@common/graphql/operations';
var actionsWithStudentAvatar = [
    ActionEnum.ActionHomeworkStudentSent,
    ActionEnum.ActionHomeworksStudentsSentCron,
    ActionEnum.ActionCourseStudentFinishCourse,
    ActionEnum.ActionChatStudentWaitAnswer_24Hour,
    ActionEnum.ActionBillingStudentPaidCourse,
];
var actionsWithCourseAvatar = [
    ActionEnum.ActionCoursePublishedNewLesson,
    ActionEnum.ActionCourseAccessStudentInvite,
    ActionEnum.ActionCourseAccessStudentExpel,
    ActionEnum.ActionCourseAccessStudentAccessEnd,
    ActionEnum.ActionCourseAccessStudentAccessEnd_3Days,
    ActionEnum.ActionCourseAccessStudentNewLesson,
    ActionEnum.ActionCourseAccessStudentNewStep,
];
var actionsWithSchoolAvatar = [
    ActionEnum.ActionBillingSchoolRequisitesDeclined,
    ActionEnum.ActionBillingSchoolRequisitesAccepted,
    ActionEnum.ActionBillingWithdrawAccepted,
    ActionEnum.ActionBillingWithdrawDecline,
];
var actionsWithSkillspace = [
    ActionEnum.ActionAffiliateRequisitesAccepted,
    ActionEnum.ActionAffiliateRequisitesDeclined,
    ActionEnum.ActionAffiliateWithdrawAccepted,
    ActionEnum.ActionAffiliateWithdrawDeclined,
];
export var useGetNotificationAvatar = function (notificationAction, notificationMeta) {
    var avatarOptions = computed(function () {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p;
        // Аватар ученика
        if (actionsWithStudentAvatar.includes(notificationAction)) {
            return {
                avatarSrc: (_a = notificationMeta.student) === null || _a === void 0 ? void 0 : _a.avatar,
                colorId: (_b = notificationMeta.student) === null || _b === void 0 ? void 0 : _b.id,
                name: (_c = notificationMeta.student) === null || _c === void 0 ? void 0 : _c.name,
            };
        }
        // Аватар курса
        if (actionsWithCourseAvatar.includes(notificationAction)) {
            return {
                avatarSrc: (_d = notificationMeta.course) === null || _d === void 0 ? void 0 : _d.avatar,
                colorId: (_e = notificationMeta.course) === null || _e === void 0 ? void 0 : _e.id,
                name: (_f = notificationMeta.course) === null || _f === void 0 ? void 0 : _f.name
            };
        }
        // Аватар партнерки
        if (actionsWithSkillspace.includes(notificationAction)) {
            return {
                avatarSrc: '/img/notifications/avatarSK1.png',
                colorId: (_g = notificationMeta.school) === null || _g === void 0 ? void 0 : _g.id,
                name: (_h = notificationMeta.school) === null || _h === void 0 ? void 0 : _h.name
            };
        }
        // Аватар школы
        if (actionsWithSchoolAvatar.includes(notificationAction)) {
            return {
                avatarSrc: ((_j = notificationMeta.school) === null || _j === void 0 ? void 0 : _j.avatar) || window.__passdata.school.avatar,
                colorId: (_k = notificationMeta.school) === null || _k === void 0 ? void 0 : _k.id,
                name: (_l = notificationMeta.school) === null || _l === void 0 ? void 0 : _l.name
            };
        }
        if (notificationAction === ActionEnum.ActionHomeworkTeacherSent || notificationAction === ActionEnum.ActionHomeworksTeacherSentCron) {
            return {
                avatarSrc: (_m = notificationMeta.teacher) === null || _m === void 0 ? void 0 : _m.avatar,
                colorId: (_o = notificationMeta.teacher) === null || _o === void 0 ? void 0 : _o.id,
                name: (_p = notificationMeta.teacher) === null || _p === void 0 ? void 0 : _p.name,
            };
        }
        // Напоминание о вебинаре
        if (notificationAction === ActionEnum.ActionCourseUpcomingWebinarStudent
            || notificationAction === ActionEnum.ActionCourseUpcomingWebinarTeacher) {
            return {
                avatarIcon: 'notifications/main/calendar-clock',
                iconColor: 'green',
            };
        }
        // Начало вебинара
        if (notificationAction === ActionEnum.ActionCourseWebinarStartStudent) {
            return {
                avatarIcon: 'notifications/main/webcam',
                iconColor: 'green',
            };
        }
        // Закончились места в группе
        if (notificationAction === ActionEnum.ActionCourseAccessGroupStudentLimitOver) {
            return {
                avatarIcon: 'notifications/main/team-check',
                iconColor: 'green',
            };
        }
        // Закончился промокод
        if (notificationAction === ActionEnum.ActionSchoolSettingsDiscountExpired) {
            return {
                avatarIcon: 'notifications/main/ticket',
                iconColor: 'blue',
            };
        }
        // Подписка закончится через 7 дней
        if (notificationAction === ActionEnum.ActionTariffSubscriptionExpirationIn_7Days) {
            return {
                avatarIcon: 'notifications/main/time-add',
                iconColor: 'blue',
            };
        }
        // Подписка закончится через 3 дня
        if (notificationAction === ActionEnum.ActionTariffSubscriptionExpirationIn_3Days) {
            return {
                avatarIcon: 'notifications/main/time-add',
                iconColor: 'orange',
            };
        }
        // Подписка закончится сегодня
        if (notificationAction === ActionEnum.ActionTariffSubscriptionExpirationIn_1Day) {
            return {
                avatarIcon: 'notifications/main/time-add',
                iconColor: 'red',
            };
        }
        // Подписка закончилась
        if (notificationAction === ActionEnum.ActionTariffSubscriptionExpired) {
            return {
                avatarIcon: 'notifications/main/hexagon-exclamation',
                iconColor: 'white',
            };
        }
        // Автоплатёж не прошел
        if (notificationAction === ActionEnum.ActionTariffSubscriptionRecurrentPaymentFailure) {
            return {
                avatarIcon: 'notifications/main/credit-card',
                iconColor: 'red',
            };
        }
        // [Лимит X] заполнен на 80% (типа повысьте тариф)
        if (notificationAction === ActionEnum.ActionTariffFeatureLimitExceeded) {
            return {
                avatarIcon: 'notifications/main/spid-clock',
                iconColor: 'blue',
            };
        }
        // Осталось три дня на выполнение задания
        if (notificationAction === ActionEnum.ActionDeadlineUpcoming_3Days) {
            return {
                avatarIcon: 'notifications/main/calendar-clock',
                iconColor: 'orange',
            };
        }
        // Остался один день на выполнение задания
        if (notificationAction === ActionEnum.ActionDeadlineUpcoming_1Day) {
            return {
                avatarIcon: 'notifications/main/calendar-clock',
                iconColor: 'red',
            };
        }
        // вы не успели выполнить задание
        if (notificationAction === ActionEnum.ActionDeadlineExpired) {
            return {
                avatarIcon: 'notifications/main/calendar-clock',
                iconColor: 'white',
            };
        }
        // Партнерская программа: новая оплата по вашей партнерской ссылке
        if (notificationAction === ActionEnum.ActionAffiliateLevelUpdate) {
            return {
                avatarIcon: 'notifications/main/add-payment',
                iconColor: 'green',
            };
        }
        if (notificationAction === ActionEnum.ActionAffiliateReferralPayment) {
            return {
                avatarIcon: 'notifications/main/two-hands',
                iconColor: 'green',
            };
        }
        return {};
    });
    var avatarClass = computed(function () {
        if (!avatarOptions.value.iconColor)
            return '';
        return {
            green: 'bg-green/10 text-green',
            orange: 'bg-orange/10 text-orange',
            red: 'bg-red-500/10 text-red-500',
            blue: 'bg-[#2AABEE]/10 text-[#2AABEE]',
            white: 'bg-red-500 text-white',
        }[avatarOptions.value.iconColor];
    });
    return __assign(__assign({}, avatarOptions.value), { avatarClass: avatarClass });
};
